import { render } from "./GreenHeader.vue?vue&type=template&id=ff1ea24a&scoped=true"
const script = {}

import "./GreenHeader.vue?vue&type=style&index=0&id=ff1ea24a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff1ea24a"]])

export default __exports__